import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import PersonRepository from '@/shared/http/repositories/configurations/person.js'

import ModalPhoneForm from './phonemodal-form.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools.js'
const ModalPhoneModel = {
  id: null,
  tipoContato: null,
  telefone: null
}

export default {
  name: 'PhoneModal',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      personId: null,
      alreadyPerson: false,
      data: ModalPhoneModel,
      form: ModalPhoneForm
    }
  },
  methods: {
    onLoad () {},
    showModal () {
      this.onClear()
      this.$refs['modal-phone'].show()
    },
    hideModal () {
      this.$refs['modal-phone'].hide()
    },
    async onCreate () {
      PersonRepository.CreateTelefone(this.card.pessoa.id, this.data)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_telefone_adicionado', 'O telefone ' + this.data.telefone + ' foi cadastrado! ', this.ip, this.latitude, this.longitude, this.card.id)
            this.$emit('Reload')
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.pop()
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/contacts/modal/phonemodal.js